function matchesAdminPath(pathname: string, patterns: readonly string[]): boolean {
  return patterns.some(pattern => (pattern.endsWith('/') ? pathname.startsWith(pattern) : pathname === pattern));
}

const restrictedAdminPathPatterns = [
  '/admin/organisations',
  '/admin/organisation/',
  '/admin/users',
  '/admin/projects',
  '/admin/sampling-points',
  '/admin/sampling-point/',
  '/admin/samples',
  '/admin/sample/',
  '/admin/chips',
] as const;

// Pages whose endpoints require a Resistomap organisation admin, so provider admins must not reach them.
const resistomapAdminOnlyPathPatterns = [
  '/admin/shipping',
  '/admin/shipments',
  '/admin/shipment',
  '/admin/shipment/',
  '/admin/sensors',
] as const;

export function isRestrictedAdminPath(pathname: string): boolean {
  return matchesAdminPath(pathname, restrictedAdminPathPatterns);
}

export function isResistomapAdminOnlyPath(pathname: string): boolean {
  return matchesAdminPath(pathname, resistomapAdminOnlyPathPatterns);
}
